type Tag = {
  tag: string;
  link: string;
};

type ArticleModule = {
  module: string;
  link: string;
};

type ArticleMethod = {
  method: string;
  link: string;
};

type Image = {
  l: string;
  s: string;
};

export type Article = {
  id: string;
  active: boolean;
  title: string;
  link: string;
  oldLink: string;
  content: string;
  summary: string;
  tags: Tag[];
  methods: ArticleMethod[];
  modules: ArticleModule[];
  images: Image;
  recommended: boolean;
  usersOnly: boolean;
  createdAt: string;
  updatedAt: string;
  htmlTitle?: string;
  htmlDescription?: string;
  altImageText: string;
  readingTime: string;
};

export type ArticleCard = Pick<Article, "id" | "link" | "recommended" | "updatedAt">;

export enum RATING_STATUS {
  NONE = "NONE",
  LIKED = "LIKED",
  DISLIKED = "DISLIKED",
}

export type UserAction = {
  success: boolean;
  allowed: boolean;
  saved: boolean;
  rating: RATING_STATUS;
};

export enum ARTICLE_TYPE {
  ARTICLE = "article",
  NEWS = "news",
}
